<wr-base-dialog status="danger"
                [header]="header"
                submitText="Löschen"
                (submit)="onDelete()"
                (close)="onCancel()">
  <wr-banner class="hint"
             status="info"
             [icon]="{ icon: 'info-outline', pack: 'eva' }"
             message="Die Sensordaten bleiben erhalten und die Blöcke können später wiederhergestellt werden.">
  </wr-banner>

  <p class="message">{{ message }}</p>

  <ul class="block-list">
    @for (block of sensorBlocks; track block.id) {
      <li>
        <strong>{{ block.name || 'Unbenannter Sensor-Block' }}</strong>
        @if (block.sensors.length > 0) {
          <span class="sensor-count">
            {{ block.sensors.length }} {{ block.sensors.length | pluralize: 'Sensor' : 'Sensoren' }}
          </span>
        }
      </li>
    }
  </ul>
</wr-base-dialog>
